<script>
    import ViewLogs from "../ViewLogs.svelte";
    import ViewNotes from "../ViewNotes.svelte";
    import PeopleChooser from "../PeopleChooser.svelte";
    import CompanyChooser from "../CompanyChooser.svelte";
    import {PAGE_ID, router, navigateTo, navigateWithContextTo} from "../../stores/router";
    import {
        app_state,
        updatePromotion,
        selectPromotion,
        displayPromotion,
        addToShortlist,
        removeFromShortlist,
        selectPerson, selectDeal,
        filemanager
    } from "../../stores/misc";
    import {
        I_PROMOTION,
        I_DEAL,
        getNullPromotion,
        promotionAsObject,
        PROMOTION_LABELS,
        PROMOTION_EXPLANATION,
        DATATYPE
    } from "../../../../../../lib/datatypes";
    import {deepCopyByValue, prettyHTMLFromPlainText} from "../../../../../../lib/utils";
    import {getTimeDiffAsShortText, now, toDate} from "../../../../../../lib/dates_times";
    import {deals} from "../../stores/deals";
    import {promotions} from "../../stores/promotions";
    import Shortlist from "../Shortlist.svelte";
    import Label from "../Label.svelte";
    import RelatedPeopleList from "../RelatedPeopleList.svelte";
    import RelatedCompaniesList from "../RelatedCompaniesList.svelte";
    import FileAttachmentList from "../FileAttachmentList.svelte";
    import NextAction from "../NextAction.svelte";


    // 'Empty' display person for use when there is no selected person
    let empty_promotion_obj = promotionAsObject(getNullPromotion());

    $: selected_promotion = $app_state.selected_promotion_id === null ? empty_promotion_obj : displayPromotion($app_state.selected_promotion_id);

    $: related_people = selected_promotion !== null ? selected_promotion.related.filter(row => row.type === DATATYPE.PERSON) : [];
    $: related_companies = selected_promotion !== null ? selected_promotion.related.filter(row => row.type === DATATYPE.COMPANY) : [];

    let edited_selected_promotion = null;
    let notes = [];
    let logs = [];
    const resetStateParams = () => {
        edited_selected_promotion = null;
        notes = [];
        logs = [];
    };
    const loadNotesAndLogs = async () => {
        const response = await fetch(`/api/promotion/${$app_state.selected_promotion_id}`);
        const result = await response.json();
        notes = result.notes;
        logs = result.log;
    };
    $: (async () => {
        if($app_state.selected_promotion_id === null) {
            resetStateParams();
        } else {
            await loadNotesAndLogs();
        }
    })()

    // $: {
    //     console.log(`selected promotion id`, $app_state.selected_promotion_id, `selected promotion obj`, selected_promotion);
    // }

    const VIEW_STATE = {
        VIEWING: 0,
        EDITING: 1
    };
    let view_state = VIEW_STATE.VIEWING;

    const TAB_STATE = {
        SHORTLIST: 0,
        NOTES: 1,
        LOG: 2
    };
    let tab_state = TAB_STATE.SHORTLIST;


    const onEditPromotionClick = async () => {
        edited_selected_promotion = await deepCopyByValue(selected_promotion);
        // console.log(edited_selected_promotion);
        view_state = VIEW_STATE.EDITING;
    };

    $: edited_related_people = edited_selected_promotion !== null ? edited_selected_promotion.related.filter(row => row.type === DATATYPE.PERSON) : [];
    $: edited_related_companies = edited_selected_promotion !== null ? edited_selected_promotion.related.filter(row => row.type === DATATYPE.COMPANY) : [];

    let show_related_person_search = false;
    let show_related_company_search = false;

    const onRelatedClick = (type, id) => {
        if(edited_selected_promotion !== null) {
            edited_selected_promotion.related.push({type: type, id:id});
            edited_selected_promotion = edited_selected_promotion;
        }
        else {
            console.warn(`no promotion being edited, why was this person/company clicked?`);
        }
        show_related_person_search = false;
        show_related_company_search = false;
    };

    const resetEditingPromotion = () => {
        view_state = VIEW_STATE.VIEWING;
        edited_selected_promotion = null;
    }
    const saveEditedPromotion = async () => {
        if(edited_selected_promotion === null) console.warn('Trying to save a null edited promotion!');
        let saved_promotion = await updatePromotion(edited_selected_promotion);
        selectPromotion(saved_promotion[I_PROMOTION.ID]); // ..to reflect the changes made (otherwise doesn't pick it up)
        resetEditingPromotion();
    };

    const onAddPersonToShortList = async person_id => {
        let promotion_arr = await addToShortlist($app_state.selected_promotion_id, person_id);
        selectPromotion(promotion_arr[I_PROMOTION.ID]);
    };
    const onRemovePersonFromShortList = async person_id => {
        let promotion_arr = await removeFromShortlist($app_state.selected_promotion_id, person_id);
        selectPromotion(promotion_arr[I_PROMOTION.ID]);
    };
    const onViewPersonClicked = person_id => {
        selectPerson(person_id);
        navigateTo(PAGE_ID.VIEW_PERSON, PAGE_ID.VIEW_PROMOTION);
    };

    const onNextActionUpdated = async (e) => {
        const new_next_action = e.detail.new_next_action;
        // NB taking a full copy of the request and then going through the existing saveEditedRequest path..
        edited_selected_promotion = await deepCopyByValue(selected_promotion);
        edited_selected_promotion.next_action = new_next_action;
        await saveEditedPromotion();
    };

    let is_uploading_files = false;
    const doChooseFile = () => {
        filemanager.chooseFiles();
        is_uploading_files = true;
    };
    $: {
        if (is_uploading_files) {
            if ($filemanager.files.length > 0) {
                if (edited_selected_promotion !== null) {
                    edited_selected_promotion.files = edited_selected_promotion.files.concat($filemanager.files);
                    edited_selected_promotion = edited_selected_promotion;
                    is_uploading_files = false;
                    filemanager.resetFiles();
                    console.log('files added, full list =', edited_selected_promotion.files);
                }
            }
        }
    }


    const onBackClick = () => {
        if($router.context.previous_page_id !== null) {
            navigateTo($router.context.previous_page_id);
        }
        else {
            navigateTo(PAGE_ID.PROMOTIONS);
        }
    };
</script>


<div class="absolute top-16 right-0 bottom-0 left-0 overflow-y-auto" class:hidden={$router.current_page !== PAGE_ID.VIEW_PROMOTION}>

    <!-- Header -->
    <div class="px-4 sm:px-6 lg:px-8">

        <!--<Breadcrumbs></Breadcrumbs>-->

        <div class="h-16 flex items-center justify-between">
            <a on:click|preventDefault={onBackClick} href="/" class="flex items-center text-sm font-medium text-gray-500 hover:text-gray-700">
                <svg class="-ml-1 mr-1 h-5 w-5 flex-shrink-0 text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z" clip-rule="evenodd" />
                </svg>
                Back
            </a>
            <div class="flex flex-shrink-0 md:mt-0 md:ml-4">
                <button on:click={onEditPromotionClick}
                        type="button" class="inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">Edit</button>
                <!--<button type="button" class="ml-3 inline-flex items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">Publish</button>-->
            </div>
        </div>

    </div>

    {#if view_state === VIEW_STATE.VIEWING}
    <div class="px-4 sm:px-6 lg:px-8">

        <div class="flex justify-between">
            <!-- Promotion pill-->
            <div class="flex inline-flex items-center px-2 py-1 rounded-full ring-1 ring-inset ring-gray-300">
                <svg class="h-4 w-4 text-purple-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path d="M3.505 2.365A41.369 41.369 0 019 2c1.863 0 3.697.124 5.495.365 1.247.167 2.18 1.108 2.435 2.268a4.45 4.45 0 00-.577-.069 43.141 43.141 0 00-4.706 0C9.229 4.696 7.5 6.727 7.5 8.998v2.24c0 1.413.67 2.735 1.76 3.562l-2.98 2.98A.75.75 0 015 17.25v-3.443c-.501-.048-1-.106-1.495-.172C2.033 13.438 1 12.162 1 10.72V5.28c0-1.441 1.033-2.717 2.505-2.914z" />
                    <path d="M14 6c-.762 0-1.52.02-2.271.062C10.157 6.148 9 7.472 9 8.998v2.24c0 1.519 1.147 2.839 2.71 2.935.214.013.428.024.642.034.2.009.385.09.518.224l2.35 2.35a.75.75 0 001.28-.531v-2.07c1.453-.195 2.5-1.463 2.5-2.915V8.998c0-1.526-1.157-2.85-2.729-2.936A41.645 41.645 0 0014 6z" />
                </svg>
                <p class="ml-1 text-sm uppercase font-light text-gray-600">Promotion</p>
            </div>

            <!-- Created date -->
            <div class="flex">
                <div class="flex items-center text-sm text-gray-500">
                    <svg class="mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fill-rule="evenodd" d="M5.75 2a.75.75 0 01.75.75V4h7V2.75a.75.75 0 011.5 0V4h.25A2.75 2.75 0 0118 6.75v8.5A2.75 2.75 0 0115.25 18H4.75A2.75 2.75 0 012 15.25v-8.5A2.75 2.75 0 014.75 4H5V2.75A.75.75 0 015.75 2zm-1 5.5c-.69 0-1.25.56-1.25 1.25v6.5c0 .69.56 1.25 1.25 1.25h10.5c.69 0 1.25-.56 1.25-1.25v-6.5c0-.69-.56-1.25-1.25-1.25H4.75z" clip-rule="evenodd" />
                    </svg>
                    <p>Created
                        <time datetime="{selected_promotion.created}">{getTimeDiffAsShortText(now().valueOf() - toDate(selected_promotion.created))}</time>
                    </p>
                </div>
            </div>
        </div>


        <div class="mt-4 flex items-center">
            <p class="text-sm text-gray-500 mr-2 align-baseline">For:</p>
            <span class="inline-flex align-text-bottom"><Label type={'deal'}></Label></span>
            <h1
                    on:click={() => {
                            selectDeal(selected_promotion.id_deal);
                            navigateTo(PAGE_ID.VIEW_DEAL, PAGE_ID.VIEW_PROMOTION);
                        }}
                    class="ml-1 text-lg font-medium text-gray-900 hover:text-indigo-500 cursor-pointer">
                {selected_promotion.id_deal === '' ? '' : $deals.lookup[selected_promotion.id_deal][I_DEAL.TITLE]}
            </h1>
        </div>

        <p class="mt-4 font-semibold text-gray-900">
            {@html selected_promotion.title}
        </p>
        <p class="mt-4 text-gray-900">
            {@html prettyHTMLFromPlainText(selected_promotion.description)}
        </p>

        <NextAction type="promotion" owner_id={selected_promotion.id} next_action={selected_promotion.next_action}
                    on:nextActionUpdate={onNextActionUpdated}
                    on:logsChanged={loadNotesAndLogs}></NextAction>

        {#if related_people.length > 0}
<!--            <p class="mt-4 text-sm text-gray-500">Related People:</p>-->
            <RelatedPeopleList related_people={related_people} return_page_id={PAGE_ID.VIEW_PROMOTION}></RelatedPeopleList>
        {/if}

        {#if related_companies.length > 0}
<!--            <p class="mt-4 text-sm text-gray-500">Related Companies:</p>-->
            <RelatedCompaniesList related_companies={related_companies} return_page_id={PAGE_ID.VIEW_PROMOTION}></RelatedCompaniesList>
        {/if}

        {#if selected_promotion.files.length > 0}
            <div class="my-4">
<!--                <p class="mt-4 text-sm text-gray-500">Files:</p>-->
                <FileAttachmentList files={selected_promotion.files}></FileAttachmentList>
            </div>
        {/if}

    </div>
    {/if}
    {#if view_state === VIEW_STATE.EDITING}
    <div class="px-4 sm:px-6 lg:px-8">

        <p class="text-sm font-medium text-gray-600">{@html PROMOTION_EXPLANATION}</p>

        <div class="mt-4">
            <label for="promotion-title" class="block text-sm font-medium text-gray-900">Promotion Title</label>
            <input bind:value="{edited_selected_promotion.title}" type="text" name="promotion-title" id="promotion-title" class="mt-1 block w-full rounded-md border-gray-300 text-gray-900 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm">
            <p class="mt-3 text-sm italic text-gray-500">({@html PROMOTION_LABELS.TITLE})</p>
        </div>

        <div class="mt-4">
            <label for="description" class="block text-sm font-medium text-gray-900">Description</label>
            <div class="mt-1">
                    <textarea bind:value={edited_selected_promotion.description}
                              id="description" name="description" rows="4"
                              class="block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"></textarea>
            </div>
            <p class="mt-3 text-sm italic text-gray-500">({@html PROMOTION_LABELS.DESCRIPTION})</p>
        </div>

        <div class="mt-4">
            <p class="block text-sm font-medium text-gray-900">Related People</p>
            <RelatedPeopleList related_people={edited_related_people} return_page_id={PAGE_ID.VIEW_PROMOTION}></RelatedPeopleList>
            {#if !show_related_person_search}
                <button on:click={() => show_related_person_search = true}
                        type="button"
                        class="mt-2 inline-flex items-center justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-100"
                >Add Related Person</button>
            {:else}
                <PeopleChooser
                        type="box"
                        current_search_str=""
                        minimise_box_without_search={true}
                        allow_adding_people={false}
                        on:personClicked={(e) => onRelatedClick(DATATYPE.PERSON, e.detail.id)}
                        on:cancelClicked={() => show_related_person_search = false}></PeopleChooser>
            {/if}
        </div>

        <div class="mt-4">
            <p class="block text-sm font-medium text-gray-900">Related Companies</p>
            <RelatedCompaniesList related_companies={edited_related_companies} return_page_id={PAGE_ID.VIEW_PROMOTION}></RelatedCompaniesList>
            {#if !show_related_company_search}
                <button on:click={() => show_related_company_search = true}
                        type="button"
                        class="mt-2 inline-flex items-center justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-100"
                >Add Related Company</button>
            {:else}
                <CompanyChooser
                        type="box"
                        current_search_str=""
                        minimise_box_without_search={true}
                        allow_adding_company={false}
                        on:companyClicked={(e) => onRelatedClick(DATATYPE.COMPANY, e.detail.id)}
                        on:cancelClicked={() => show_related_company_search = false}></CompanyChooser>
            {/if}
        </div>

        <div class="my-4">
            <p class="block text-sm font-medium text-gray-900">Files</p>
            {#if edited_selected_promotion.files.length > 0}
                <div class="mt-2">
                    <FileAttachmentList files={edited_selected_promotion.files}></FileAttachmentList>
                </div>
            {/if}
            {#if $filemanager.is_uploading}
                <div class="flex items-center justify-center rounded-md border border-transparent bg-orange-600 px-2 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                ><svg class="animate-spin self-center w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
                </svg>
                    Sending..</div>
            {/if}
            <button on:click={doChooseFile}
                    type="button"
                    class="mt-2 inline-flex items-center justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:ring-offset-gray-100"
            >Add File</button>
        </div>

        <div class="flex justify-end pt-8">
            <button on:click={resetEditingPromotion}
                    type="button"
                    class="rounded-md border border-gray-300 bg-white py-2 px-4 text-sm font-medium text-gray-900 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >Cancel</button>
            <button on:click={saveEditedPromotion}
                    type="submit"
                    class="ml-3 inline-flex justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
            >Save</button>
        </div>

    </div>
    {/if}

    <div class="block mt-6">
        <div class="border-b border-gray-200">
            <nav class="-mb-px px-4 flex justify-between sm:justify-start space-x-8" aria-label="Tabs">
                <a href="/" on:click|preventDefault={() => tab_state = TAB_STATE.SHORTLIST} class="{tab_state === TAB_STATE.SHORTLIST ? `border-indigo-500 text-indigo-600` : `border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700` } group inline-flex items-center border-b-2 py-4 px-1 text-sm font-medium">
                    <svg class="{tab_state === TAB_STATE.SHORTLIST ? `text-indigo-500` : `text-gray-400 group-hover:text-gray-500`} -ml-0.5 mr-2 h-5 w-5" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zM3.75 12h.007v.008H3.75V12zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm-.375 5.25h.007v.008H3.75v-.008zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
                    </svg>
                    <span>ShortList</span>
                </a>

                <a href="/" on:click|preventDefault={() => tab_state = TAB_STATE.NOTES} class="{tab_state === TAB_STATE.NOTES ? `border-indigo-500 text-indigo-600` : `border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700` } group inline-flex items-center border-b-2 py-4 px-1 text-sm font-medium">
                    <svg class="{tab_state === TAB_STATE.NOTES ? `text-indigo-500` : `text-gray-400 group-hover:text-gray-500`} -ml-0.5 mr-2 h-5 w-5"  fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 01.865-.501 48.172 48.172 0 003.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z" />
                    </svg>
                    <span>Notes</span>
                </a>

                <a href="/" on:click|preventDefault={() => tab_state = TAB_STATE.LOG} class="{tab_state === TAB_STATE.LOG ? `border-indigo-500 text-indigo-600` : `border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700` } group inline-flex items-center border-b-2 py-4 px-1 text-sm font-medium" aria-current="page">
                    <svg class="{tab_state === TAB_STATE.LOG ? `text-indigo-500` : `text-gray-400 group-hover:text-gray-500`} -ml-0.5 mr-2 h-5 w-5" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                    </svg>
                    <span>Log</span>
                </a>
            </nav>
        </div>
    </div>

    {#if tab_state === TAB_STATE.SHORTLIST}

    <Shortlist
            shortlist_people_arr={selected_promotion.list_shortlist_people}
            on:addPersonToShortlist={(e) => onAddPersonToShortList(e.detail.id)}
            on:removePersonFromShortlist={(e) => onRemovePersonFromShortList(e.detail.id)}
            on:viewPersonClicked={(e) => onViewPersonClicked(e.detail.id)}
    ></Shortlist>

    <div class="px-4 sm:px-6 lg:px-8">

        <!-- TODO implement the button at the bottom of the shortlist -->
        <div class="h-16 flex items-center justify-end">
            <div class="flex flex-shrink-0">
                <button on:click={() => console.log(`to implement Edit Shortlist Clicked!`)}
                        type="button" class="relative inline-flex items-center rounded-md border border-transparent bg-indigo-500 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-800">
                    <!-- Heroicon name: mini/plus -->
                    <svg class="-ml-1 mr-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path d="M10.75 4.75a.75.75 0 00-1.5 0v4.5h-4.5a.75.75 0 000 1.5h4.5v4.5a.75.75 0 001.5 0v-4.5h4.5a.75.75 0 000-1.5h-4.5v-4.5z" />
                    </svg>
                    <span>..to implement</span>
                </button>
            </div>
        </div>

    </div>
    {/if}

    {#if tab_state === TAB_STATE.NOTES}
    <ViewNotes type="promotion" owner_id={selected_promotion.id} bind:notes></ViewNotes>
    {/if}

    {#if tab_state === TAB_STATE.LOG}
    <ViewLogs type="promotion" owner_id={selected_promotion.id} bind:logs></ViewLogs>
    {/if}

</div>


<style></style>